import { useState } from "react";

/**
 * The product in one control: the link, and the one gesture anybody performs
 * on it. Copying sweeps a beam across the bar so the click has an answer.
 */
export function LinkBar({ url, label }: { url: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(false);
    requestAnimationFrame(() => setCopied(true));
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="stack stack--tight">
      {label ? <span className="meta">{label}</span> : null}
      <div className={`linkbar${copied ? " linkbar--copied" : ""}`}>
        <a className="linkbar__url" href={url} target="_blank" rel="noreferrer">
          {url.replace(/^https?:\/\//, "")}
        </a>
        <button className="button" type="button" onClick={copy}>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
